import { render } from "./GeneratePackageSummaryModal.vue?vue&type=template&id=49545ff1&scoped=true"
import script from "./GeneratePackageSummaryModal.vue?vue&type=script&lang=js"
export * from "./GeneratePackageSummaryModal.vue?vue&type=script&lang=js"

import "./GeneratePackageSummaryModal.vue?vue&type=style&index=0&id=49545ff1&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49545ff1"]])

export default __exports__